const WindowSizeThresholdsEnum = {
	// 815 is default for WindowSizeProvider
	Small: 815,
	Medium: 1030,
};

export default WindowSizeThresholdsEnum;
